import React from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import Guidance from '../../../../../components/Guidance';
import BookHeader from '../../../components/BookHeader';
import BookLogHistory from '../../ViewBook/components/BookLogHistory';
import Reading from './Reading';
import Completed from './Completed';
import { BOOK_STATUS } from '../../../../../services/constants';
import styles from '../../ViewBook/components/BookHolder.module.scss';

const GROUP_BOOK_TYPE = 4;

const BookHolder = ({ groupBook }) => {

    const { t } = useTranslation();
    const guidance = {
        started: t('reading_log_instructions'),
        completed: t('well_done_you_finished_the_book'),
    };

    const renderContent = () => {
        switch (groupBook.status) {
            case BOOK_STATUS.new:
            case BOOK_STATUS.started:
                return { book: <Reading groupBook={groupBook} />, info: guidance.started };
            case BOOK_STATUS.completed:
                return { book: <Completed />, info: guidance.completed };
            default:
                return { book: '-', info: '-' };
        }
    };

    const content = renderContent();
    const bookHeaderData = { ...groupBook, bookType: GROUP_BOOK_TYPE };

    return (
        <div className={styles.bookPage}>
            <div className={cx('page-wrapper', styles.bookPageRow)}>
                <div className="page-wrapper__main">
                    <div className={cx('content-panel', styles.bookPanel)}>
                        <BookHeader studentBook={bookHeaderData} />
                    </div>
                </div>
            </div>

            <div className={cx('page-wrapper', styles.bookPageRow)}>
                <div className={cx('page-wrapper__main', styles.bookFormMain)}>
                    <div className={cx('content-panel', styles.bookPanel)}>
                        {content.book}
                    </div>
                    <div className={cx('content-panel', styles.bookPanel, styles.bookStackedPanel)}>
                        <BookLogHistory logs={groupBook.logs} />
                    </div>
                </div>
                <div className={cx('page-wrapper__side', styles.guidanceColumn)}>
                    <Guidance text={content.info} readingPage />
                </div>
            </div>
        </div>
    );
};

export default BookHolder;
